<template>
  <div class="page-wrapper">
    <!-- <myheader></myheader> -->
    <!-- <mybody> -->
    <cmp-header v-if="!['home', 'login'].includes(currentRouter)" :type="2"></cmp-header>
    <router-view v-if="viewFlag || ['login'].includes(currentRouter)"></router-view>
    <!-- </mybody> -->
    <myfooter></myfooter>
  </div>
</template>

<script>
import cmpHeader from "./header.vue";
import publicUrl from "../../assets/js/interface";
import myfooter from "./footer.vue";
import { mapMutations } from "vuex";
export default {
  name: "page-wrapper",
  components: {
    cmpHeader,
    myfooter,
  },
  data() {
    return {
      viewFlag: false,
      currentRouter: "",
    };
  },

  watch: {
    $route: {
      handler: function(to) {
        this.currentRouter = to.name;
      },
      immediate: true,
    },
  },
  created() {
    if (localStorage.token) this.getUserInfo();
  },
  mounted() {
    window.vm = this;
    document.addEventListener("click", () => {
      this.$jstools.myEvent.dispatchEvent("progressClick", { id: -1 });
    });
  },
  methods: {
    ...mapMutations(["setUserInfo"]),

    getUserInfo() {
      this.loadingCount++;
      this.$ajax
        .get(publicUrl.currentUser)
        .then((res) => {
          if (res.data.code === 0) {
            let _data = res.data.data || {};
            this.$root.$ajax.defaults.headers.token = _data.token;
            this.$root.$ajaxJson.defaults.headers.token = _data.token;
            this.setUserInfo(_data);
            this.$jstools.myEvent.dispatchEvent("current-user");
            if (["login"].includes(this.$route.name)) {
              window.location.href = "/";
              // this.$router.push({ name: "home" });
            }
          } else {
            this.setUserInfo();
            // this.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
          this.setUserInfo();
        })
        .finally(() => {
          this.viewFlag = true;
          this.loadingCount--;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped></style>
